import React, { useState } from 'react';
import TopNavbar from '../home/TopNavbar';

const schedulePresets = {
  school: {
    label: 'School / College Going Student (6–7 Hrs JEE Daily)',
    timetable: [
      { time: '05:30 AM – 07:00 AM', block: 'Morning Deep Focus', subject: 'Mathematics (Calculus / Algebra Problem Practice)', type: 'math' },
      { time: '07:00 AM – 07:30 AM', block: 'Prep & Commute', subject: 'Breakfast, bag pack, school transit', type: 'break' },
      { time: '08:00 AM – 02:00 PM', block: 'School Hours', subject: 'Board/School curriculum classes', type: 'school' },
      { time: '02:00 PM – 03:30 PM', block: 'Recovery', subject: 'Lunch, light walk, physical relaxation', type: 'break' },
      { time: '03:30 PM – 06:00 PM', block: 'Afternoon Blitz', subject: 'Physics (NCERT concept + 15–20 numericals)', type: 'physics' },
      { time: '06:00 PM – 06:45 PM', block: 'Reset Break', subject: 'Snacks, outdoor walk / social reset', type: 'break' },
      { time: '06:45 PM – 09:15 PM', block: 'Evening Deep Focus', subject: 'Chemistry (Organic/Inorganic/Physical daily target)', type: 'chemistry' },
      { time: '09:15 PM – 10:00 PM', block: 'Dinner', subject: 'Family dinner, disconnect screens', type: 'break' },
      { time: '10:00 PM – 11:00 PM', block: 'Night Review', subject: 'Formula revision, error log notes, plan tomorrow', type: 'revision' }
    ]
  },
  dropper: {
    label: 'Dropper / Full-Time Aspirant (11–12 Hrs JEE Daily)',
    timetable: [
      { time: '06:30 AM – 07:00 AM', block: 'Wakeup & Prime', subject: 'Hydration, light stretching, sunlight exposure', type: 'break' },
      { time: '07:00 AM – 10:00 AM', block: 'Session 1 (Heavy Math)', subject: 'Mathematics core PYQ execution & high-weightage topics', type: 'math' },
      { time: '10:00 AM – 10:45 AM', block: 'Breakfast Break', subject: 'Balanced meal, zero digital scroll', type: 'break' },
      { time: '10:45 AM – 01:45 PM', block: 'Session 2 (Physics)', subject: 'Physics theory + multi-concept numerical practice', type: 'physics' },
      { time: '01:45 PM – 02:45 PM', block: 'Lunch & Nap', subject: 'Lunch + 25-minute power nap', type: 'break' },
      { time: '02:45 PM – 05:45 PM', block: 'Session 3 (Chemistry)', subject: 'Chemistry block (Reaction mechanisms / coordination / physical)', type: 'chemistry' },
      { time: '05:45 PM – 06:30 PM', block: 'Physical Exercise', subject: 'Run, gym, badminton, or team sport', type: 'break' },
      { time: '06:30 PM – 08:30 PM', block: 'Session 4 (Backlog / Speed Drills)', subject: 'Timed sectional micro-quiz (30 mins) + Weak sub-topic fix', type: 'revision' },
      { time: '08:30 PM – 09:15 PM', block: 'Dinner Break', subject: 'Dinner, relaxation', type: 'break' },
      { time: '09:15 PM – 10:30 PM', block: 'Night Consolidation', subject: 'Short notes update, formula flashcard walk-through', type: 'revision' }
    ]
  }
};

const weekChecklist = [
  { day: 'Monday', core: 'Math: Sequence & Series + Physics: Current Electricity', chemTarget: 'Coordination Compounds Naming & VBT', mock: false },
  { day: 'Tuesday', core: 'Math: Quadratic Equations + Physics: Electrostatics', chemTarget: 'Aldehydes/Ketones Name Reactions', mock: false },
  { day: 'Wednesday', core: 'Math: Limits & Differentiability + Physics: Ray Optics', chemTarget: 'Equilibrium (Ionic/Chemical numericals)', mock: false },
  { day: 'Thursday', core: 'Math: 3D Geometry + Physics: Magnetism', chemTarget: 's-Block & p-Block NCERT lines', mock: false },
  { day: 'Friday', core: 'Math: Definite Integration + Physics: Modern Physics', chemTarget: 'Organic Conversion Practice Set', mock: false },
  { day: 'Saturday', core: 'Sectional Timed Drills (PCM Mixed 75 Questions)', chemTarget: 'Error Log Re-solve & Formula Sheet Review', mock: true },
  { day: 'Sunday', core: 'Full NTA CBT Mock Test (9 AM – 12 PM)', chemTarget: '3-Hour Post-Mock Root Cause Error Analysis', mock: true }
];

export default function StudyTimeTable() {
  const [profile, setProfile] = useState('dropper');
  const [completedSlots, setCompletedSlots] = useState({});

  const toggleSlot = (idx) => {
    const key = `${profile}-${idx}`;
    setCompletedSlots((prev) => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const activeSchedule = schedulePresets[profile];

  const getBadgeStyle = (type) => {
    switch (type) {
      case 'math':
        return { bg: '#dbeafe', color: '#1e40af', label: 'MATH' };
      case 'physics':
        return { bg: '#ccfbf1', color: '#0f766e', label: 'PHYSICS' };
      case 'chemistry':
        return { bg: '#ede9fe', color: '#6d28d9', label: 'CHEMISTRY' };
      case 'school':
        return { bg: '#f1f5f9', color: '#334155', label: 'SCHOOL' };
      case 'revision':
        return { bg: '#fef3c7', color: '#92400e', label: 'REVISION' };
      default:
        return { bg: '#f3f4f6', color: '#4b5563', label: 'BREAK' };
    }
  };

  return (
    <>
      <style>{`
        .jeet-mobile-shell {
          width: 100%;
          min-height: 100vh;
          background-color: #f9fafb;
          box-sizing: border-box;
          overflow-x: hidden;
          padding-bottom: 90px;
          margin-top: 50px;
        }
        .jeet-mobile-shell *, 
        .jeet-mobile-shell *::before, 
        .jeet-mobile-shell *::after {
          box-sizing: border-box;
          min-width: 0;
        }
        .jeet-container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 16px 12px;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          color: #1f2937;
        }
        .jeet-header {
          text-align: center;
          margin-bottom: 16px;
        }
        .jeet-header h1 {
          font-size: 1.35rem;
          font-weight: 800;
          color: #111827;
          margin: 0 0 6px 0;
          word-break: break-word;
        }
        .jeet-header p {
          color: #4b5563;
          font-size: 0.8rem;
          line-height: 1.45;
          max-width: 750px;
          margin: 0 auto;
          word-break: break-word;
        }
        .jeet-toolbar {
          display: flex;
          flex-direction: column;
          background: #ffffff;
          padding: 12px;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
          margin-bottom: 16px;
          gap: 10px;
        }
        .jeet-toggle-group {
          display: flex;
          gap: 6px;
          width: 100%;
        }
        .jeet-profile-btn {
          flex: 1;
          padding: 8px 10px;
          border-radius: 6px;
          font-size: 0.78rem;
          font-weight: 600;
          border: 1px solid #d1d5db;
          background: #f3f4f6;
          color: #374151;
          cursor: pointer;
          transition: all 0.2s;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .jeet-profile-btn.active {
          background: #111827;
          color: #ffffff;
          border-color: #111827;
        }
        .jeet-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }
        .jeet-card {
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
          padding: 14px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }
        .jeet-card-header {
          display: flex;
          flex-direction: column;
          gap: 6px;
          margin-bottom: 12px;
          border-bottom: 1px solid #f3f4f6;
          padding-bottom: 8px;
        }
        .jeet-card-header h2 {
          font-size: 1rem;
          font-weight: 700;
          color: #111827;
          margin: 0;
          word-break: break-word;
        }
        .jeet-table-wrapper {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .jeet-table {
          width: 100%;
          min-width: 520px;
          border-collapse: collapse;
          font-size: 0.78rem;
        }
        .jeet-table th, .jeet-table td {
          padding: 9px 8px;
          border-bottom: 1px solid #f3f4f6;
          text-align: left;
          word-break: break-word;
        }
        .jeet-table th {
          background: #f8fafc;
          color: #374151;
          font-weight: 600;
          font-size: 0.7rem;
          text-transform: uppercase;
        }
        .jeet-row {
          cursor: pointer;
          transition: background-color 0.15s;
        }
        .jeet-row:hover {
          background-color: #f8fafc;
        }
        .jeet-row.done {
          background-color: #f0fdf4;
        }
        .jeet-row.done td {
          color: #166534;
        }
        .jeet-time-tag {
          font-family: monospace;
          font-weight: 600;
          color: #1e293b;
          white-space: nowrap;
          font-size: 0.72rem;
        }
        .jeet-subject-badge {
          display: inline-block;
          padding: 3px 6px;
          border-radius: 999px;
          font-size: 0.65rem;
          font-weight: 700;
          white-space: nowrap;
        }
        .jeet-checkbox {
          width: 15px;
          height: 15px;
          cursor: pointer;
          accent-color: #16a34a;
        }
        .jeet-weekly-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 10px;
        }
        .jeet-weekly-card {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 10px;
        }
        .jeet-day-title {
          font-weight: 700;
          color: #1e3a8a;
          margin-bottom: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.88rem;
        }
        .jeet-day-content {
          font-size: 0.78rem;
          color: #475569;
          line-height: 1.4;
          word-break: break-word;
        }
        .jeet-mock-tag {
          font-size: 0.62rem;
          background: #fee2e2;
          color: #991b1b;
          padding: 2px 5px;
          border-radius: 4px;
          font-weight: 600;
          white-space: nowrap;
        }

        /* Desktop adaptations */
        @media (min-width: 640px) {
          .jeet-mobile-shell {
            padding-bottom: 24px;
          }
          .jeet-container {
            padding: 24px 16px;
          }
          .jeet-header h1 {
            font-size: 1.85rem;
          }
          .jeet-header p {
            font-size: 0.95rem;
          }
          .jeet-toolbar {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
          .jeet-toggle-group {
            width: auto;
          }
          .jeet-profile-btn {
            flex: unset;
            padding: 8px 16px;
          }
          .jeet-card-header {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
          .jeet-card-header h2 {
            font-size: 1.2rem;
          }
          .jeet-table {
            min-width: 100%;
            font-size: 0.88rem;
          }
          .jeet-table th, .jeet-table td {
            padding: 12px 14px;
          }
          .jeet-time-tag {
            font-size: 0.82rem;
          }
          .jeet-weekly-grid {
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 12px;
          }
          .jeet-weekly-card {
            padding: 14px;
          }
          .jeet-day-content {
            font-size: 0.82rem;
          }
        }
      `}</style>

      <div className="jeet-mobile-shell">

                <TopNavbar name="Time table" ></TopNavbar>

        <div className="jeet-container">
          <header className="jeet-header">
            <h1>JEE Main Daily & Weekly Master Time Table</h1>
            <p>
              Tap any daily schedule row to mark it complete. Switch seamlessly between school-going and dropper daily routines.
            </p>
          </header>

          <div className="jeet-toolbar">
            <div className="jeet-toggle-group">
              <button
                className={`jeet-profile-btn ${profile === 'dropper' ? 'active' : ''}`}
                onClick={() => setProfile('dropper')}
              >
                Dropper / Full-Time
              </button>
              <button
                className={`jeet-profile-btn ${profile === 'school' ? 'active' : ''}`}
                onClick={() => setProfile('school')}
              >
                School / College Student
              </button>
            </div>
            <span style={{ fontSize: '0.78rem', color: '#4b5563', fontWeight: 600, wordBreak: 'break-word' }}>
              Active Profile: {activeSchedule.label}
            </span>
          </div>

          <div className="jeet-grid">
            {/* Daily Schedule Table */}
            <div className="jeet-card">
              <div className="jeet-card-header">
                <h2>Daily Execution Breakdown</h2>
                <span className="jeet-subject-badge" style={{ background: '#e0f2fe', color: '#0369a1' }}>
                  Tap Row to Check
                </span>
              </div>
              <div className="jeet-table-wrapper">
                <table className="jeet-table">
                  <thead>
                    <tr>
                      <th>Done</th>
                      <th>Time Window</th>
                      <th>Category</th>
                      <th>Block Focus</th>
                      <th>Actionable Task</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeSchedule.timetable.map((slot, idx) => {
                      const badge = getBadgeStyle(slot.type);
                      const isChecked = !!completedSlots[`${profile}-${idx}`];
                      return (
                        <tr
                          key={idx}
                          className={`jeet-row ${isChecked ? 'done' : ''}`}
                          onClick={() => toggleSlot(idx)}
                        >
                          <td>
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => {}}
                              className="jeet-checkbox"
                            />
                          </td>
                          <td className="jeet-time-tag">{slot.time}</td>
                          <td>
                            <span
                              className="jeet-subject-badge"
                              style={{ background: badge.bg, color: badge.color }}
                            >
                              {badge.label}
                            </span>
                          </td>
                          <td><strong>{slot.block}</strong></td>
                          <td>{slot.subject}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {/* 7-Day Macro Rotation */}
            <div className="jeet-card">
              <div className="jeet-card-header">
                <h2>7-Day Macro Subject Rotation Blueprint</h2>
                <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>Repeat weekly</span>
              </div>
              <div className="jeet-weekly-grid">
                {weekChecklist.map((item, idx) => (
                  <div key={idx} className="jeet-weekly-card">
                    <div className="jeet-day-title">
                      <span>{item.day}</span>
                      {item.mock && <span className="jeet-mock-tag">MOCK / DRILL</span>}
                    </div>
                    <div className="jeet-day-content">
                      <p style={{ margin: '0 0 4px 0' }}><strong>PCM Focus:</strong> {item.core}</p>
                      <p style={{ margin: 0 }}><strong>Chemistry Target:</strong> {item.chemTarget}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}